import { HTTPStatuses } from 'constants/http';
import { FETCH_USER_PAYMENTS_FAILURE } from 'constants/payment';
import { FETCH_USER_FAILURE } from 'constants/user';
import type { RootState } from 'reducers/types';
import type { Middleware } from 'redux';
import { errorNotifier } from 'utils/errorNotifier/errorNotifier';

const isUnauthorized = (error: { status: HTTPStatuses } | undefined) =>
  error?.status === HTTPStatuses.UNAUTHORIZED;

const isReportable = (actionType: string) => {
  switch (actionType) {
    case FETCH_USER_PAYMENTS_FAILURE:
    case FETCH_USER_FAILURE:
      return true;
    default:
      return false;
  }
};

const ErrorLogger: Middleware<unknown, RootState> =
  () => next => (action: unknown) => {
    const { type, payload } = action as {
      type: string;
      payload?: Error & { status?: HTTPStatuses; message?: string };
    };
    const shouldNotifyError =
      isReportable(type) &&
      !isUnauthorized(payload as { status: HTTPStatuses });

    if (shouldNotifyError && payload) {
      errorNotifier.notifyWithFingerprint(payload as Error, [
        type,
        payload.message,
      ]);
    }

    return next(action);
  };

export { ErrorLogger };
